import React from 'react';
import cn from 'classnames';
// import Label from './Label';
import FormError from './FormError';
import FormHint from './FormHint';
import arrowDownIcon from '../../assets/arrow-down.svg';
import { breakpoints, colors } from '../config';

const Select = ({
  id,
  label = '',
  hint = '',
  options = [],
  readOnly = false,
  register,
  placeholder,
  defaultValue,
  error,
  ...rest
}) => (
  <div className={cn('select', { 'select-readonly': readOnly })}>
    <label htmlFor={id}>{label}</label>

    <select
      id={id}
      readOnly={readOnly}
      ref={register}
      defaultValue={defaultValue}
      {...rest}
      required
    >
      {placeholder && (
        <option value="" disabled={true} hidden={true}>
          {placeholder}
        </option>
      )}

      {options.map((option, i) => (
        <option key={`${id}-${i}`} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    {hint && <FormHint>{hint}</FormHint>}
    {error && <FormError>{error.message}</FormError>}

    <style jsx>{`
      .select {
        margin-bottom: 32px;

        /* Fix offset with input field */
        position: relative;
        top: 1px;
      }

      .select-readonly {
        border-bottom: 1px solid ${colors.lighterGrey};
        margin-bottom: 32px;
        padding-bottom: 24px;
      }

      label {
        color: ${colors.brown};
        display: block;
        font-size: 14px;
        font-weight: bold;
      }

      @media screen and (min-width: ${breakpoints.md}) {
        label {
          font-weight: 900;
        }
      }

      select {
        appearance: none;
        background-color: transparent;
        background-image: url(${arrowDownIcon});
        background-position: right 0 top 50%, 0 0;
        background-repeat: no-repeat, repeat;
        border: 0;
        border-bottom: 1px solid ${colors.inputBorderColor};
        border-radius: 0;
        box-sizing: border-box;
        color: #444;
        display: block;
        font-family: inherit;
        font-size: 16px;
        font-weight: inherit;
        margin: 0;
        max-width: 100%;
        padding: 8px 0 8px 0;
        width: 100%;
        transition: opacity 0.25s ease;
      }

      select::-ms-expand {
        display: none;
      }

      select:focus {
        border-color: ${colors.orange};
        /* outline: none; */
      }

      select[readonly] {
        background-image: none;
        border-bottom: 0;
        color: #26221f;
        pointer-events: none;
      }

      select[readonly]:focus {
        outline: 0;
      }

      select option {
        font-weight: normal;
        padding: 0;
      }

      select:disabled,
      select[aria-disabled='true'] {
        color: ${colors.textMuted};
        opacity: 0.5;
      }

      select:disabled:hover,
      select[aria-disabled='true'] {
        border-color: ${colors.lighterGrey};
      }

      select:required:invalid {
        color: ${colors.textMuted};
      }

      option {
        color: ${colors.baseTextColor};
      }
    `}</style>
  </div>
);

export default Select;
